export default __webpack_public_path__ + "static/media/Available-Amount.80b6248a.svg";